import toast from "react-hot-toast";
import axiosInstance from "../../services/axiosInstance";
import { useQuery } from "@tanstack/react-query";
const instance = axiosInstance();

export async function getPersonalRecommendations() {
  const response = await instance.get(
    `/search-federal/personal_recommendations`
  );
  return response.data;
}
export function useGetRecommendations() {
  return useQuery({
    queryKey: ["personalRecommendations"],
    queryFn: getPersonalRecommendations,
    onError: (e) => {
      if (e.response?.data?.detail) toast.error(e.response?.data?.detail);
    },
  });
}
